package com.milta.web

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.remember
import com.milta.core.localization.LocalStrings
import com.milta.feature.profile.domain.usecase.GetProfileUseCase
import com.milta.feature.profile.domain.usecase.UpdateLanguageUseCase
import com.milta.feature.settings.presentation.AdminSettingsIntent
import com.milta.feature.settings.presentation.AdminSettingsViewModel
import org.jetbrains.compose.web.dom.Div
import org.koin.compose.koinInject

/**
 * Admin "Paramètres" screen (2026-10-05) — a trimmed-down sibling of [WebSettingsContent]: reuses
 * its [LanguageCard]/[LegalCard] as-is (account-level language preference and legal documents apply
 * identically to an Admin account), but deliberately drops the Organisation profile card, the
 * subscription card and the Organisation-deletion critical zone — an Admin account has no
 * Organisation/Subscription (see [Screen.AdminDashboard]'s doc in Main.kt).
 */
@Composable
fun AdminSettingsContent(
    onLanguageChanged: (String) -> Unit,
    onNavigateToTerms: () -> Unit = {},
    onNavigateToPrivacy: () -> Unit = {},
) {
    val getProfile: GetProfileUseCase = koinInject()
    val updateLanguage: UpdateLanguageUseCase = koinInject()
    val viewModel = remember { AdminSettingsViewModel(getProfile, updateLanguage) }
    val state by viewModel.state.collectAsState()

    // Mirrors WebSettingsContent's own LaunchedEffect(state.language) — applies both the initial
    // load and any explicit change to the whole web interface immediately.
    LaunchedEffect(state.language) {
        val lang = state.language
        if (!lang.isNullOrBlank()) onLanguageChanged(lang)
    }

    val strings = LocalStrings.current.settings

    Div(
        attrs = {
            style {
                property("display", "flex"); property("flex-direction", "column")
                property("gap", "18px"); property("max-width", "420px")
            }
        },
    ) {
        LanguageCard(strings, state.language ?: "en", state.languageError) { viewModel.onIntent(AdminSettingsIntent.SelectLanguage(it)) }
        LegalCard(strings, onNavigateToTerms = onNavigateToTerms, onNavigateToPrivacy = onNavigateToPrivacy)
    }
}
